if (!window.HeroBannerSimple) {
  class HeroBannerSimple {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.enableAddToCart = container.dataset.enableAddToCart === 'true';
      this.directCheckout = container.dataset.directCheckout === 'true';
      this.variantId = container.dataset.variantId;
      this.sellingPlanId = container.dataset.sellingPlanId;

      // RA_PT_PDP_4 | Free Travel Mug — Var A adds the gift set that keeps the mug, falling back
      // to the control payload when the selected variant carries no `_abtest` bundle.
      const giftsAttr =
        (window.cFreeTravelMugVarA?.() && container.dataset.giftsAbtest) || container.dataset.gifts;
      try {
        this.gifts = JSON.parse(giftsAttr || '[]');
      } catch (e) {
        this.gifts = [];
      }

      this.setupElements();
      this.initAddToCart();
    }

    setupElements() {
      this.addToCartBtn = this.container.querySelector('[data-add-to-cart-btn]');
    }

    initAddToCart() {
      if (!this.enableAddToCart || !this.addToCartBtn || !this.variantId) return;

      this.addToCartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleAddToCart();
      });
    }

    async handleAddToCart() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.addToCartBtn.disabled = true;

      try {
        const items = [];

        if (this.gifts && this.gifts.length > 0) {
          this.gifts.forEach(gift => {
            if (gift.id) {
              items.push({
                id: gift.id,
                quantity: 1,
                properties: {
                  '_gift': 'true',
                  '_parent_variant': this.variantId.toString()
                }
              });
            }
          });
        }

        const mainItem = {
          id: parseInt(this.variantId, 10),
          quantity: 1
        };

        if (this.sellingPlanId) {
          mainItem.selling_plan = parseInt(this.sellingPlanId, 10);
        }

        items.push(mainItem);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        if (this.directCheckout) {
          window.location.href = '/checkout';
        } else {
          const sidecart = document.querySelector('side-cart');
          if (sidecart && typeof sidecart.refreshCartAndOpen === 'function') {
            sidecart.refreshCartAndOpen(true);
          }
        }
      } catch (error) {
        console.error('Add to cart error:', error);
      } finally {
        this.isSubmitting = false;
        this.addToCartBtn.disabled = false;
      }
    }
  }

  window.HeroBannerSimple = HeroBannerSimple;

  document.querySelectorAll('[data-section-type="hero-banner-simple"]').forEach((container) => {
    container.heroBannerSimpleInstance = new HeroBannerSimple(container);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-section-type="hero-banner-simple"]');
    if (container) {
      container.heroBannerSimpleInstance = new HeroBannerSimple(container);
    }
  });
}
